import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./view/containers/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import Store from "./state/store";

const store = Store();

// React 18 API
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
